<template>
  <div class="vlevel" :class="extraclass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VerticalLevel',
  props: {
    extraclass: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>

.vlevel {
    width: 100%;
    flex-shrink: 1; // This makes the text wrap
    display: flex;
    flex-direction: column;

    .vlevel-item {
      width: 100%;
      text-align: left;
      flex: 1;
    }
}

</style>
